module.exports = __webpack_public_path__ + "static/Marketplace1-7ab1f177ace1363aee6455744fe3b0ab.png";